// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"b923f604","144":"74648475","2429":"0a09d294","3679":"74648475","4082":"cab58a88","4670":"37b37aa0","5921":"032bdccd","6427":"c74d9ab4"}[chunkId] + ".chunk.css";
};